/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationData } from './PaginationData';
import {
    PaginationDataFromJSON,
    PaginationDataFromJSONTyped,
    PaginationDataToJSON,
    PaginationDataToJSONTyped,
} from './PaginationData';
import type { ConsumerProofOfDelivery } from './ConsumerProofOfDelivery';
import {
    ConsumerProofOfDeliveryFromJSON,
    ConsumerProofOfDeliveryFromJSONTyped,
    ConsumerProofOfDeliveryToJSON,
    ConsumerProofOfDeliveryToJSONTyped,
} from './ConsumerProofOfDelivery';

/**
 * Paginated list of proofs of delivery for a consumer.
 * @export
 * @interface PaginatedConsumerProofsOfDelivery
 */
export interface PaginatedConsumerProofsOfDelivery {
    /**
     * List of proofs of delivery.
     * @type {Array<ConsumerProofOfDelivery>}
     * @memberof PaginatedConsumerProofsOfDelivery
     */
    results: Array<ConsumerProofOfDelivery>;
    /**
     * 
     * @type {PaginationData}
     * @memberof PaginatedConsumerProofsOfDelivery
     */
    pagination: PaginationData;
}

/**
 * Check if a given object implements the PaginatedConsumerProofsOfDelivery interface.
 */
export function instanceOfPaginatedConsumerProofsOfDelivery(value: object): value is PaginatedConsumerProofsOfDelivery {
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function PaginatedConsumerProofsOfDeliveryFromJSON(json: any): PaginatedConsumerProofsOfDelivery {
    return PaginatedConsumerProofsOfDeliveryFromJSONTyped(json, false);
}

export function PaginatedConsumerProofsOfDeliveryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedConsumerProofsOfDelivery {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(ConsumerProofOfDeliveryFromJSON)),
        'pagination': PaginationDataFromJSON(json['pagination']),
    };
}

export function PaginatedConsumerProofsOfDeliveryToJSON(json: any): PaginatedConsumerProofsOfDelivery {
    return PaginatedConsumerProofsOfDeliveryToJSONTyped(json, false);
}

export function PaginatedConsumerProofsOfDeliveryToJSONTyped(value?: PaginatedConsumerProofsOfDelivery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'results': ((value['results'] as Array<any>).map(ConsumerProofOfDeliveryToJSON)),
        'pagination': PaginationDataToJSON(value['pagination']),
    };
}

